import { createFileRoute } from "@tanstack/react-router";
import { DeleteAccountPage } from "@/modules/users/presentation/pages/DeleteAccountPage";

export const Route = createFileRoute("/excluir-conta")({
  component: DeleteAccountPage,
});
